import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
import { CTAButton } from './ui/CTAButton';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
export function HeroSection() {
  const bullets = ['Si tienes horas muertas entre citas aunque seas el mejor en tu zona', 'Si para llenar la agenda tienes que publicar ofertas de 50% de descuento que solo atraen clientes de una sola vez', 'Si tu Instagram tiene seguidores pero no se convierten en citas reales', 'Si dependes del "boca a boca" para conseguir clientes nuevos', 'Si tus estilistas están parados varias horas al día esperando clientes'];
  return <section className="relative pt-24 pb-16 md:pt-32 md:pb-24 px-4 overflow-hidden" data-id="element-25">
      <div className="max-w-4xl mx-auto" data-id="element-26">
        <motion.div initial="hidden" animate="visible" variants={containerVariants} className="flex flex-col items-center text-center md:text-left md:items-start" data-id="element-27">
          <motion.h1 variants={itemVariants} className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-gold leading-tight mb-6" data-id="element-28">
            ¿Tu silla vacía le está costando $500 al día a tu negocio?
          </motion.h1>

          <motion.p variants={itemVariants} className="text-lg md:text-xl text-gray-300 mb-10 max-w-3xl leading-relaxed" data-id="element-29">
            Llenamos tu agenda de citas confirmadas con clientes que pagan el
            precio completo, no con buscadores de cupones de descuento que nunca
            vuelven.
          </motion.p>

          <motion.ul variants={containerVariants} className="space-y-4 mb-10 w-full max-w-2xl" data-id="element-30">
            {bullets.map((bullet, index) => <motion.li key={index} variants={itemVariants} className="flex items-start text-left" data-id="element-31">
                <CheckCircle2Icon className="w-6 h-6 text-emerald shrink-0 mr-4 mt-0.5" data-id="element-32" />
                <span className="text-gray-200 md:text-lg" data-id="element-33">{bullet}</span>
              </motion.li>)}
          </motion.ul>

          <motion.div variants={itemVariants} className="w-full text-center md:text-left mb-8" data-id="element-34">
            <p className="text-gold font-bold text-xl italic" data-id="element-35">
              Esto es para ti.
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="w-full flex flex-col items-center md:items-start" data-id="element-36">
            <CTAButton className="w-full md:w-auto text-lg" data-id="element-37">
              QUIERO MI AGENDA LLENA ESTA SEMANA
            </CTAButton>
            <p className="text-gray-400 text-sm mt-4" data-id="element-38">
              Diagnóstico gratuito en 15 minutos.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}